import store from '../store'
export function FilterPermissions (slug) {
  let data = store.getters.permission
  if (data.permissionList === undefined) {
    return store.dispatch('GetUserPermission', false).then(
      () => checkingPermissions(data, slug)
    )
  } else {
    return checkingPermissions(data, slug)
  }
}
function checkingPermissions (data, slug) {
  if (data.isAdmin === true) {
    return true
  } else if (slug === '') {
    return true
  } else {
    if (slug === undefined) {
      return false
    } else if (data.permissionList !== undefined) {
      let isPermissionAvailable = data.permissionList.find(val => {
        return val.entityPermissionsSlug === slug
      })
      return isPermissionAvailable !== undefined
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/Permissions.js